

<template>
  <section class="container" style="margin-top: 5rem">
    <div>
      <!-- Modal Structure Eventos -->
      <div id="modal-eventos" class="modal">
        <div class="modal-content">
          <h4>Eventos</h4>
          <div>
            <ul class="collapsible popout">
              <li v-for="(evento, key) in eventos" :key="key">
                <div class="collapsible-header">
                  <i class="mdi mdi-clock-outline"></i>
                  {{ evento.created.toDate().toLocaleString() }} -
                  {{ evento.status }} (Toca para saber más)
                </div>
                <div class="collapsible-body">
                  <p>
                    <span>{{ evento.desc }}</span>
                    <span v-show="evento.paqueteria_numero_rastreo">
                      Proveedor del servicio: {{ evento.paqueteria_name }}
                      <br />
                      Número de rastreo: {{ evento.paqueteria_numero_rastreo }}
                      <br />
                      Web de rastreo:
                      <a
                        :href="evento.paqueteria_web_rastreo"
                        target="_blank"
                        >{{ evento.paqueteria_web_rastreo }}</a
                      >
                    </span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <a class="modal-close waves-effect waves-green btn-flat">Cerrar</a>
        </div>
      </div>
    </div>

    <div class="">
      <div v-if="total_cartons > 0" class="card-content">
        <div class="card-title flow-text">Pedido #{{ no_orden }}</div>
        <ul class="collapsible">
          <li v-for="(cartons, key) in jobparts" :key="key">
            <div class="collapsible-header">
              <i class="mdi mdi-calendar-multiple-check"></i>
              Trabajo #{{ key }}
            </div>
            <div class="collapsible-body">
              <ul class="collection with-header">
                <li
                  class="collection-item"
                  v-for="(carton, key) in cartons"
                  :key="key"
                >
                  <div class="">
                    <h5>
                      Carton {{ carton.no_carton }} de
                      {{ carton.total_cartons }}
                    </h5>

                    <h5>{{ carton.status }}</h5>
                    {{ carton.status_desc }}
                    <br />
                    Actualizado
                    {{ carton.updated_at.toDate().toLocaleString() }}

                    <p style="margin-top: 2rem">
                      <button @click="carton_clicked(carton)" class="btn green">
                        Ver eventos
                      </button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <div v-show="total_cartons < 0">
        <blockquote class="flow-text">
          Cargando información para el trabajo #{{ no_orden }} ...
        </blockquote>
      </div>
      <div v-show="!total_cartons">
        <blockquote class="flow-text">
          Aún no hay actualizaciones para el trabajo #{{ no_orden }} <br />
          <button @click="obtenerDetalles" class="btn green">ACTUALIZAR</button>
        </blockquote>
      </div>
    </div>
  </section>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";
export default {
  props: {
    orden: {
      type: String,
    },
  },
  created() {
    setTimeout(() => {
      this.modal_eventos = M.Modal.init(
        document.querySelector("#modal-eventos"),
        {}
      );
    }, 0);
    this.no_orden =
      this.orden || prompt("Ingresa tu número de orden o trabajo:");
    this.obtenerDetalles();
  },
  updated() {
    setTimeout(() => {
      var elems = document.querySelectorAll(".collapsible");
      M.Collapsible.init(elems, {});
    }, 0);
  },
  methods: {
    obtenerDetalles() {
      let no_orden = this.no_orden.toUpperCase();
      this.no_orden = no_orden;
      let query = this.db.collection("cartons");
      if (no_orden && no_orden.startsWith("D")) {
        query = query.where("ccmasterid", "==", no_orden);
      } else {
        query = query.where("dsforderid", "==", no_orden);
      }
      query.get().then((snap) => {
        M.toast({ html: "Actualizado satisfactoriamente", classes: "green" });
        console.log("cartons", snap.docs.length);
        this.total_cartons = snap.docs.length;
        if (snap.docs.length) {
          this.cartons = {};
          snap.docs.forEach((doc) => {
            this.cartons[doc.id] = doc.data();
          });
          this.$forceUpdate();
        }
      });
    },
    carton_clicked(carton) {
      this.carton = carton;
      this.modal_eventos.open();
    },
  },
  computed: {
    eventos() {
      if (!this.carton.eventos) return [];
      return [...this.carton.eventos].reverse();
    },
    jobparts() {
      let cartons = Object.values(this.cartons),
        parts = {},
        jobparts = cartons.map((carton) => carton.jobpart);
      jobparts.forEach((jobpart) => {
        parts[jobpart] = cartons.filter((carton) => {
          return !carton.jobpart.localeCompare(jobpart);
        });
      });
      return parts;
    },
  },
  data() {
    let db = firebase.firestore();

    return {
      db: db,
      total_cartons: -1,
      no_orden: undefined,
      cartons: undefined,
      carton: {},
    };
  },
};
</script>


